export default class EmptyLegend {
  html() {
    return `
      <div class="p-6 font-bold">
        Insufficient data
      </div>
    `
  }
}
